import PropTypes from 'prop-types';

import SharedAsset from '@zenbusiness/zui/SharedAsset';

import * as Styled from './Icon.style';

/**
 * MenuItemIcon
 *
 * @param {{
 *  className?: string
 *  colorMode?: number
 *  src: string
 * }} props
 *
 * @returns {import('react').ReactNode}
 */
export default function MenuItemIcon({ className, src, size = 20 }) {
  if (!src) {
    return null;
  }

  return (
    <Styled.Root className={className} component="span">
      <SharedAsset
        alt=""
        color="#FFFFFF"
        height={size}
        src={src.startsWith('/s2') ? src : `/s2/icon/${src}`}
        width={size}
      />
    </Styled.Root>
  );
}

MenuItemIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  src: PropTypes.string.isRequired,
};
